import FooterCaption from './FooterCaption';

export default FooterCaption;
